import './OrderIcon.scss';

import React, { FunctionComponent } from 'react';
import { ReactComponent as AgentIcon } from '../../../assets/agent.svg';
import { ReactComponent as ConsumerIcon } from '../../../assets/consumer.svg';
import { ReactComponent as ShoppingBagIcon } from '../../../assets/eshop-shopping-bag.svg';
import { ReactComponent as ConsumerGuestIcon } from '../../../assets/consumer-guest.svg';
import { OrderSubType, OrderType } from './types';

export interface OrderIconProps {
    orderType: OrderType;
    orderSubType: OrderSubType;
    isGuestOrder?: boolean;
}

const resolveOrderIcon = (
    orderType: OrderType,
    orderSubType: OrderSubType,
    isGuestOrder?: boolean,
) => {
    if (orderType === OrderType.DIGITAL) {
        return <ShoppingBagIcon className="order-icon__icon" data-testid="digital-order-icon" />;
    }
    if (orderType === OrderType.PHYSICAL) {
        if (orderSubType === OrderSubType.ServiceOrderStoreMagento) {
            return <AgentIcon className="order-icon__icon" data-testid="agent-order-icon" />;
        }

        if (orderSubType === OrderSubType.MyNintendoStorePhysical) {
            return isGuestOrder ? (
                <ConsumerGuestIcon
                    className="order-icon__icon"
                    data-testid="consumer-guest-order-icon"
                />
            ) : (
                <ConsumerIcon className="order-icon__icon" data-testid="consumer-order-icon" />
            );
        }
    }
    return null;
};

const OrderIcon: FunctionComponent<OrderIconProps> = ({
    orderType,
    orderSubType,
    isGuestOrder,
}) => <div className="order-icon">{resolveOrderIcon(orderType, orderSubType, isGuestOrder)}</div>;

export default OrderIcon;
